import { handleActions } from 'redux-actions';

import { Actions } from '../actions/job-types';

const initialState = {
  loading: false,
  error: null,
  value: [],
};

export default handleActions(
  {
    [Actions.JOB_TYPES_REQUEST]: state => ({
      ...state,
      loading: true,
      error: null,
    }),
    [Actions.JOB_TYPES_SUCCESS]: (state, action) => ({
      ...state,
      loading: false,
      error: null,
      value: action.response.result,
    }),
    [Actions.JOB_TYPES_FAILURE]: (state, action) => ({
      ...state,
      loading: false,
      error: action.error,
      value: [],
    }),
  },
  initialState
);
